import { render, staticRenderFns } from "./ImportPortfolioStep2.vue?vue&type=template&id=7ef0cdfb&"
import script from "./ImportPortfolioStep2.vue?vue&type=script&lang=js&"
export * from "./ImportPortfolioStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports